import React, { useEffect, useState } from 'react';
import { Header, Segment, Pagination } from 'semantic-ui-react';
import { connect } from 'react-redux'
import moment from 'moment'

import TitleBar from '../../../titleBar/title_bar';
import AgGridTable from '../../../common/agGridTable';
import LoadingPlaceholder from '../../../placeholderComponent/loadingPlaceholder'
import PaymentActionButton from './paymentActionButton';

import { deleteBill, getVendorBills } from '../../../../redux/actions/billActions';
import { getBillingPurchaseOrder } from '../../../../redux/actions/purchaseOrderActions';
import PurchaseOrderActionButton from './billActionButton';
import { DATE_DDMMYYYY } from '../../../../utils/constant';

function POTable(props) {
  const { purchaseOrderLoading, getVendorBills, deleteBill, deleteBillIsLoading, getBillingPurchaseOrder } = props;

  const [purchaseOrderData, setPurchaseOrderData] = useState()
  const [currentPage, setCurrentPage]= useState(1)
  const [totalPages, setTotalPages] = useState(1)
  
  let vendorCode = localStorage.getItem("vendorCode")
  useEffect(() => {
    getPurchaseOrders(vendorCode, currentPage)
  }, [getBillingPurchaseOrder]);

  const getPurchaseOrders = async(vendorCode, pageNo, searchString=null) => {
    await getBillingPurchaseOrder(vendorCode, pageNo, searchString).then((res) => {
      if (res?.resultSet?.pending_purchase_orders.length > 0) {
        setPurchaseOrderData(res?.resultSet?.pending_purchase_orders)
        let total_pages = res.resultSet?.pagination_constraints?.total_count ? Math.ceil(Number(res.resultSet?.pagination_constraints?.total_count) / 10) : 1
        setTotalPages(total_pages)
      }else{
        setPurchaseOrderData([])
        setTotalPages(1)
      }
    })
  }

  const handlePaginationChange = (e, { activePage }) => {
    setCurrentPage(activePage)
    getPurchaseOrders(vendorCode, activePage)
  };

  const searchPurchaseOrder= (searchTerm) =>{
      getPurchaseOrders(vendorCode, currentPage, searchTerm)
  }

    const customerNo = localStorage.getItem('customerNumber')

    let vendorHeader = {}

    if (customerNo != 1158) {
      vendorHeader.vendorName = "Vendor Name"
      vendorHeader.vendorBillNo = "Vendor Bill No."
      vendorHeader.vendorBillDate = "Vendor Bill Date"
    } else {
      vendorHeader.vendorName = "Partner Name"
      vendorHeader.vendorBillNo = "Partner Bill No."
      vendorHeader.vendorBillDate = "Partner Bill Date"
    }

    let columnDefs = [
      { headerName: 'PO No.', field: 'poNumber', tooltipField: 'poNumber', enableRowGroup: true, enablePivot: true, filter: true },
      { headerName: 'Order No.', field: 'order_no', tooltipField: 'order_no', enableRowGroup: true, enablePivot: true, filter: true },
      { headerName: 'PO Date', field: 'poDate', tooltipField: 'poDate', enableRowGroup: true, enablePivot: true, filter: true },
      { headerName: 'Reference No.', field: 'refNo', tooltipField: 'refNo', enableRowGroup: true, enablePivot: true, filter: true },
      { headerName: 'Partner Name', field: 'vendorName', tooltipField: 'vendorName', enableRowGroup: true, enablePivot: true, filter: true },
      { headerName: 'Amount', field: 'amount', tooltipField: 'amount', enableRowGroup: true, enablePivot: true, filter: true },
      { headerName: 'Branch', field: 'branch', tooltipField: 'branch', enableRowGroup: true, enablePivot: true, filter: true },
      { headerName: 'remarks', field: 'remarks', tooltipField: 'remarks', enableRowGroup: true, enablePivot: true, filter: true },
      { headerName: 'Vehicle', field: 'vehicle', tooltipField: 'vehicle', enableRowGroup: true, enablePivot: true, filter: true },
      { headerName: 'Created On', field: 'createdOn', tooltipField: 'createdOn', enableRowGroup: true, enablePivot: true, filter: true },
      { headerName: 'Created By', field: 'createdBy', tooltipField: 'createdBy', enableRowGroup: true, enablePivot: true, filter: true },
      { headerName: 'Modified On', field: 'modifiedOn', tooltipField: 'modifiedOn', enableRowGroup: true, enablePivot: true, filter: true },
      { headerName: 'Modified By', field: 'modifiedBy', tooltipField: 'modifiedBy', enableRowGroup: true, enablePivot: true, filter: true },
      { headerName: 'Edit', field: 'edit', cellRenderer: 'actionRenderer', width: 280, suppressToolPanel: true, pinned: "right" }
    ]

    let frameworkComponents = {
      actionRenderer: PurchaseOrderActionButton,
      paymentModalRenderer: PaymentActionButton,
    }

    let rowData = []

    purchaseOrderData && purchaseOrderData.forEach((object, index) => {
      let temp = {}
      temp.poNumber = object.po_details.poNumber
      temp.order_no = object.order_no
      temp.poDate = moment(object.poDate).format(DATE_DDMMYYYY) === "Invalid date" ? "" : moment(object.poDate).format(DATE_DDMMYYYY)
      temp.refNo = object.po_details.poReferenceNo
      temp.vendorName = object.po_details.vendorName
      temp.vendorId = object.po_details.vendorId
      temp.vendorGroup = object.po_details.purchasePrice
      temp.amount = object.po_details.totalOrderAmt
      temp.branch = object.po_details.branchName
      temp.vehicle = object.po_details.vehicleNo
      temp.remarks = object.po_details.remarks
      temp.createdOn = object.po_details.createdOn
      temp.createdBy = object.po_details.createdByName
      temp.modifiedOn = object.po_details.updatedOn
      temp.modifiedBy = object.po_details.updatedByName
      temp.psLineItem = object.po_details
      temp.poId = object.po_details.poId
      temp.isUsed = object.po_details.isUsed
      rowData[index] = temp
    })
    return (
      <React.Fragment>
        <AgGridTable
          columnDefs={columnDefs}
          rowData={rowData}
          searchValue={props.searchValue}
          titleBarLink="/add-bill"
          baseURL={props}
          hiddenNewPopupBtn={true}
          hiddenImportPopupBtn={true}
          extraComponents={frameworkComponents}
          titleBarTitle="Purchase Orders"
          handleSearch={props.handleSearch}
          hideNew={true}
          hideFilter={true}
          pagination={false}
          customSearch={searchPurchaseOrder}
          statusLoading={purchaseOrderLoading}
        />

          <div
            className="life-cycle w3-white ui pagination menu"
          >
            <Pagination
              defaultActivePage={currentPage}
              firstItem={null}
              lastItem={null}
              onPageChange={handlePaginationChange}
              pointing
              secondary
              totalPages={totalPages}
            />
          </div>
      </React.Fragment>
    )
  }


const mapStatetoProps = (state) => ({
  purchaseOrderLoading: state.getPurchaseOrderReducer.isLoading,
})
export default connect(mapStatetoProps, { getVendorBills, deleteBill, getBillingPurchaseOrder })(POTable)